import Grid from '@material-ui/core/Grid';
import * as React from 'react';
import {connect} from "react-redux";
import {PAGE_TYPE, RECORDS_SORT_BY} from '../../Config/appConfig';
import authState from '../../ReduxRequests/State/authState';
import SortButton from '../Custom/SortButton';

interface RecordsTableViewHeaderProps {
    page: string,
    sortBy?: string,
    clickSort?: (sortBy: string) => void,
    isInsurer?: () => boolean
}

class RecordsTableViewHeader extends React.Component <RecordsTableViewHeaderProps, {}> {
    public getHeaderTitle() {
        let colTitle1 = '';
        const colTitle2 = this.props.isInsurer() ? 'Sub-agent Company' : 'Insurance Company';
        switch (this.props.page) {
            case PAGE_TYPE.COVER_NOTE:
                colTitle1 = 'Cover Note Number';
                break;
            case PAGE_TYPE.POLICY:
                colTitle1 = 'Policy Number';
                break;
            case PAGE_TYPE.ARCHIVED:
            case PAGE_TYPE.SEARCH:
                colTitle1 = 'Document Number';
                break;
            default: break;
        }
        return {colTitle1, colTitle2}
    }

    public render() {
        return (
            <div className="cmTableViewHeader">
                <Grid className="cmTableViewHeaderCol" item xs={2}>
                    <div className={`cmTableViewHeaderContainer${this.props.sortBy === RECORDS_SORT_BY.DAY_LEFT ? " cmTableViewHeaderContainerFocused" : ""}`}>
                        <div className="cmTableViewHeaderTitle">Day Left</div>
                        {this.props.clickSort && <SortButton clickSort={() => this.props.clickSort(RECORDS_SORT_BY.DAY_LEFT)} isFocused={this.props.sortBy === RECORDS_SORT_BY.DAY_LEFT}/>}
                    </div>
                </Grid>
                <Grid className="cmTableViewHeaderCol" item xs={2}>
                    <div className={`cmTableViewHeaderContainer${this.props.sortBy === RECORDS_SORT_BY.ISSUE_NO ? " cmTableViewHeaderContainerFocused" : ""}`}>
                        <div className="cmTableViewHeaderTitle">{this.getHeaderTitle().colTitle1}</div>
                        {this.props.clickSort && <SortButton clickSort={() => this.props.clickSort(RECORDS_SORT_BY.ISSUE_NO)} isFocused={this.props.sortBy === RECORDS_SORT_BY.ISSUE_NO}/>}
                    </div>
                </Grid>
                <Grid className="cmTableViewHeaderCol" item xs={4}>
                    <div className={`cmTableViewHeaderContainer${this.props.sortBy === RECORDS_SORT_BY.COMPANY ? " cmTableViewHeaderContainerFocused" : ""}`}>
                        <div className="cmTableViewHeaderTitle">{this.getHeaderTitle().colTitle2}</div>
                        {this.props.clickSort && <SortButton clickSort={() => this.props.clickSort(RECORDS_SORT_BY.COMPANY)} isFocused={this.props.sortBy === RECORDS_SORT_BY.COMPANY}/>}
                    </div>
                </Grid>
                <Grid className="cmTableViewHeaderCol" item xs={2}>
                    <div className={`cmTableViewHeaderContainer${this.props.sortBy === RECORDS_SORT_BY.LICENSE ? " cmTableViewHeaderContainerFocused" : ""}`}>
                        <div className="cmTableViewHeaderTitle">License Plate Number</div>
                        {this.props.clickSort && <SortButton clickSort={() => this.props.clickSort(RECORDS_SORT_BY.LICENSE)} isFocused={this.props.sortBy === RECORDS_SORT_BY.LICENSE}/>}
                    </div>
                </Grid>
                <Grid className="cmTableViewHeaderCol" item xs={2}>
                    <div className={`cmTableViewHeaderContainer${this.props.sortBy === RECORDS_SORT_BY.END_DATE ? " cmTableViewHeaderContainerFocused" : ""}`}>
                        <div className="cmTableViewHeaderTitle">End Date</div>
                        {this.props.clickSort && <SortButton clickSort={() => this.props.clickSort(RECORDS_SORT_BY.END_DATE)} isFocused={this.props.sortBy === RECORDS_SORT_BY.END_DATE}/>}
                    </div>
                </Grid>
            </div>
        );
    }

}

export default connect(authState, null)(RecordsTableViewHeader);



// WEBPACK FOOTER //
// ./src/Components/Records/RecordsTableViewHeader.tsx